import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { CommonService, AuthenticationService, ChatService } from '../../_services';
import { TranslateService } from '@ngx-translate/core';
import { delay } from "rxjs/operators";

@Component({
    selector: 'chatapp',
    templateUrl: 'chatapp.component.html',
})

export class ChatappComponent implements OnInit, OnDestroy {

    @ViewChild('scrollChat', { static: false }) scrollChat: ElementRef;
    @Input() gameCode: string;
    @Output() messageEvent = new EventEmitter<string>();

    message = {};
    messageType: any;
    contact = false;
    playerlist: any;
    user: any;
    room: String;
    messageText = '';
    messageArray = [];
    userInfo: any;
    player: any;
    userlist = [];
    chatStatus = 'ACTIVE';
    playerChatData: any;
    isNearBottom = true;
    scrollContainer: any;
    userInfoLocalSubscription: Subscription;
    newUserSubscription: Subscription;
    userLeftSubscription: Subscription;
    msgRecSubscription: Subscription;
    userCountSubscription: Subscription;
    showEmojiPicker = false;
    sets = [
        'apple',
        'google',
        'twitter',
        'emojione',
        'messenger',
        'facebook'
    ]
    set = 'google';
    sentMessageIndex = [];
    colorMapUser = [];
    colorNextPointer = 0;
    totalUserColor = 16;

    constructor(
        private chatService: ChatService,
        private authenticationService: AuthenticationService,
        private commonService: CommonService,
        private translate: TranslateService,
    ) { }

    ngOnInit() {
        this.userInfoLocalSubscription = this.authenticationService.subscribeuserInfoLocal().subscribe((response) => {
            this.userInfo = response;
            this.user = this.userInfo.playername;
            // this.messageArray.push({ message: "", user: "Welcome " + this.user, state: "join" });
        });

        this.authenticationService.getUserInfoLocal();

        this.newUserSubscription = this.chatService.newUserJoined().pipe(delay(0)).subscribe(data => {
            this.messageArray.push(data);
            if (this.isNearBottom) {
                this.scrollToBottom();
            }
        });

        this.userLeftSubscription = this.chatService.userLeftRoom().pipe(delay(0)).subscribe(data => {
            this.messageArray.push(data);
            if (this.isNearBottom) {
                this.scrollToBottom();
            }
        });

        this.msgRecSubscription = this.chatService.newMessageReceived().subscribe(data => {
            if (data.user != this.user) {
                this.messageArray.push(data);
            } else {
                let tempIndex = this.sentMessageIndex.shift();
                if (typeof tempIndex != 'undefined') {
                    this.messageArray[tempIndex] = data;
                } else {
                    this.messageArray.push(data);
                }
            }
            if (this.isNearBottom) {
                this.scrollToBottom();
            }
        });

        this.userCountSubscription = this.chatService.userCount().pipe(delay(0)).subscribe((response: any) => {
            this.userlist = [];
            for (const property in response.playerMaster[this.gameCode]) {
                this.userlist.push(response.playerMaster[this.gameCode][property].username);
                if (!this.checkUserColor(response.playerMaster[this.gameCode][property].username)) {
                    if (typeof this.colorMapUser[this.colorNextPointer] == 'undefined') {
                        this.colorMapUser.push([response.playerMaster[this.gameCode][property].username]);
                    } else {
                        this.colorMapUser[this.colorNextPointer].push(response.playerMaster[this.gameCode][property].username);
                    }
                    this.colorNextPointer = (++this.colorNextPointer) % this.totalUserColor;
                }
            }
            try {
                this.playerChatData = response.playerMaster[this.gameCode][this.user];
                this.chatStatus = this.playerChatData.status;
            }
            catch (e) {
                this.chatStatus = 'ACTIVE';
            }
        });
    }

    ngAfterViewInit() {
        this.scrollContainer = this.scrollChat.nativeElement;
        if (this.isNearBottom) {
            this.scrollToBottom();
        }
    }

    checkUserColor(username) {
        if (username != this.user) {
            for (let i = 0; i < this.colorMapUser.length; i++) {
                for (let j = 0; j < this.colorMapUser[i].length; j++) {
                    if (username == this.colorMapUser[i][j]) {
                        return i;
                    }
                }
            }
        }
        return false;
    }

    sendMessage() {
        this.messageText = this.messageText.trim();
        if (this.messageText != '') {
            if (!this.messageText.match(/\s/g) || this.messageText.match(/(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/) || this.messageText.match(/[a-z,A-Z,0-9]/g)) {
                this.messageArray.push({ state: 'message', user: this.user, room: this.gameCode, message: this.messageText });
                this.sentMessageIndex.push(this.messageArray.length - 1);
                this.chatService.serverSendMessage({ user: this.user, room: this.gameCode, message: this.messageText });
            }
        }
        if (this.showEmojiPicker) {
            this.toggleEmojiPicker();
        }
        this.messageText = '';
        this.scrollToBottom();
    }

    handleKeyUp(event: any) {
        if (event.keyCode == 13 && this.messageText != '') {
            this.sendMessage();
        }
    }

    leaveChat() {
        this.messageEvent.emit('close');
    }

    viewContact() {
        this.contact = !this.contact;
    }

    toggleEmojiPicker() {
        this.showEmojiPicker = !this.showEmojiPicker;
    }

    addEmoji(event, chatArea) {
        let startIndex = 0;
        if (chatArea.selectionStart || chatArea.selectionStart == '0') {
            startIndex = chatArea.selectionStart;
        }
        let startText = this.messageText.substring(0, startIndex) + event.emoji.native;
        let endText = this.messageText.substring(startIndex);
        this.messageText = startText + endText;
        chatArea.focus();
        setTimeout(() => {
            chatArea.selectionStart = startText.length;
            chatArea.selectionEnd = startText.length;
        }, 0);
    }

    ngOnDestroy() {
        if (typeof this.userInfoLocalSubscription != 'undefined') {
            this.userInfoLocalSubscription.unsubscribe();
        }
        // if (typeof this.newUserSubscription != 'undefined') {
        //     this.newUserSubscription.unsubscribe();
        // }
        // if (typeof this.userLeftSubscription != 'undefined') {
        //     this.userLeftSubscription.unsubscribe();
        // }
        // if (typeof this.msgRecSubscription != 'undefined') {
        //     this.msgRecSubscription.unsubscribe();
        // }
        // if (typeof this.userCountSubscription != 'undefined') {
        //     this.userCountSubscription.unsubscribe();
        // }
    }

    private scrollToBottom(): void {
        setTimeout(() => {
            this.scrollContainer.scroll({
                top: this.scrollContainer.scrollHeight,
                left: 0,
                behavior: 'smooth'
            });
        }, 100);
    }

    private isUserNearBottom(): boolean {
        const threshold = 150;
        const position = this.scrollContainer.scrollTop + this.scrollContainer.offsetHeight;
        const height = this.scrollContainer.scrollHeight;
        return position > height - threshold;
    }

    scrolled(event: any): void {
        this.isNearBottom = this.isUserNearBottom();
    }

}
